import React from "react";
import PT from "prop-types";
import "./textfield.m.css";

export const TextField = ({ value, type, error, ...props }) => {
  return (
    <div styleName="wrapper" className="wrapper-textfield">
      <input
        type={type}
        value={value || ""}
        styleName={`textfield ${props.disabled ? "disabled" : ""}`}
        {...props}
        className="textfield"
      />
      {error && <div styleName="error">{error}</div>}
    </div>
  );
};

TextField.defaultProps = {
  type: "email"
};

TextField.propTypes = {
  type: PT.string,
  value: PT.string,
  error: PT.string,
  disabled: PT.bool
};
